import React, { useLayoutEffect } from "react";
import { EyeMedLogo, VisionBrochure } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBVisionImage from "../../../../../assets/VEBPlanImages/VEBVisionImage.avif";
import "./vision.scss";

const Vision: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="vision-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Vision Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={EyeMedLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							When you or a loved one is diagnosed with a significant eye vision condition, the financial
							strain can become daunting. While primary vision insurance may assist with some of the
							optical expenses, individuals often encounter difficulties related to time away from work
							and costs that may not be covered by other insurance policies.
						</span>

						<h3>Stay focused on getting well</h3>
						<span>
							A Eye Med Vision Insurance policy offers an additional layer of financial security during
							challenging times related to eye vision issues. It provides benefits that can be utilized to
							manage expenses and safeguard your savings, allowing you to concentrate on improving your
							vision health.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBVisionImage} alt="VEB Vision Image" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={VisionBrochure} />
			</div>
		</div>
	);
};

export default Vision;
